import { i18n } from "@tellescope/i18n";

export type FreeformOperation =
  | "equals"
  | "does_not_equal"
  | "is_set"
  | "is_not_set"
  | "contains"
  | "does_not_contain"
  | "before"
  | "after"
  | "less_than"
  | "greater_than";

export interface FreeformFilter {
  field: string;
  operation: FreeformOperation;
  value?: string | number;
}

export interface FreeformFieldOption {
  value: string;
  label: string;
  valueType: "string" | "number" | "date";
}

export const NO_VALUE_OPERATIONS: FreeformOperation[] = ["is_set", "is_not_set"];

export const NUMERIC_OPERATIONS: FreeformOperation[] = ["less_than", "greater_than"];

export const DATE_OPERATIONS: FreeformOperation[] = ["before", "after"];

export const STRING_OPERATIONS: FreeformOperation[] = ["contains", "does_not_contain"];

export const getAllFreeformOperations: () => Array<{ value: FreeformOperation; label: string }> = () => [
  { value: "equals", label: i18n.t("equals") },
  { value: "does_not_equal", label: i18n.t("doesn't equal") },
  { value: "is_set", label: i18n.t("is set") },
  { value: "is_not_set", label: i18n.t("is not set") },
  { value: "contains", label: i18n.t("contains") },
  { value: "does_not_contain", label: i18n.t("does not contain") },
  { value: "before", label: i18n.t("before") },
  { value: "after", label: i18n.t("after") },
  { value: "less_than", label: i18n.t("less than") },
  { value: "greater_than", label: i18n.t("greater than") },
];

export const buildMdbFilterFromFreeform = (freeformFilters: FreeformFilter[]): Record<string, unknown> => {
  const mdbFilter: Record<string, unknown> = {};

  freeformFilters.forEach((filter) => {
    const op = filter.operation;
    if (NO_VALUE_OPERATIONS.includes(op)) {
      mdbFilter[filter.field] = op === "is_set" ? { $exists: true, $nin: [null, ""] } : { $in: [null, ""] };
    } else if (op === "equals") {
      mdbFilter[filter.field] = filter.value;
    } else if (op === "does_not_equal") {
      mdbFilter[filter.field] = { $ne: filter.value };
    } else if (op === "contains") {
      mdbFilter[filter.field] = { $regex: filter.value, $options: "i" };
    } else if (op === "does_not_contain") {
      mdbFilter[filter.field] = { $not: { $regex: filter.value, $options: "i" } };
    } else if (op === "before" || op === "less_than") {
      mdbFilter[filter.field] = { $lt: filter.value };
    } else if (op === "after" || op === "greater_than") {
      mdbFilter[filter.field] = { $gt: filter.value };
    }
  });

  return mdbFilter;
};
